import type { RrMainMenuItemImpl } from '@seedkit/vue';

export type SidebarUnreadBadgesView = {
  badges: Readonly<Record<string, number>>;
  dotMenuIds: Readonly<Set<string>>;
};

/**
 * Seedkit рендерит бейдж только при truthy `badge`.
 * Для точки без цифры значение не отображается — см. CSS для `.rr-main-menu-item-expanded`.
 */
const SEEDKIT_DOT_BADGE_TRIGGER = 1;

export function applyUnreadBadgesToMenu(
  items: RrMainMenuItemImpl[],
  { badges, dotMenuIds }: SidebarUnreadBadgesView,
): RrMainMenuItemImpl[] {
  return items.map((item) => {
    const count = badges[ item.id ];
    const isDot = dotMenuIds.has(item.id);
    const children = item.children?.length
      ? applyUnreadBadgesToMenu(item.children as RrMainMenuItemImpl[], { badges, dotMenuIds })
      : undefined;

    const next: RrMainMenuItemImpl = { ...item };

    if (isDot) {
      next.badge = SEEDKIT_DOT_BADGE_TRIGGER;
    } else if (count !== undefined && count > 0) {
      next.badge = count;
    } else {
      delete next.badge;
    }

    if (children?.length) {
      next.children = children;
    } else if (!item.children?.length) {
      delete next.children;
    }

    return next;
  });
}
